import jwtDecode from 'jwt-decode';

function decodeUserFromToken(token) {
  if (!token | (token === 'undefined')) {
    localStorage.clear();
    return null;
  }

  const {
    user_id,
    username,
    full_name,
    role_name,
    role_id,
    is_superuser,
    permissions,
    roles_with_tribes,
    tribe_id,
    tribe_name,
    groups_ids,
    password_old,
    session_id,
    password_set_by_admin,
  } = jwtDecode(token);

  if (
    !is_superuser &&
    (!user_id ||
      !username ||
      !tribe_id ||
      !tribe_name ||
      !roles_with_tribes ||
      !permissions ||
      !full_name ||
      !role_name ||
      !role_id ||
      !session_id)
  ) {
    localStorage.clear();
  }

  const user = {
    id: user_id,
    tribeRole: roles_with_tribes,
    tribeId: tribe_id,
    tribeName: tribe_name,
    username,
    fullName: full_name,
    role: is_superuser ? 'Суперадмин' : role_name,
    role_id,
    isSuperUser: is_superuser,
    permissions,
    groups_ids,
    password_old,
    password_set_by_admin,
  };

  return user;
}

function getUserFullname(user) {
  if (!user) return null;

  if (user.isSuperUser) {
    return 'Суперадмин';
  }

  return user.fullName;
}

export { decodeUserFromToken, getUserFullname };
